module.exports = __webpack_public_path__ + "img/product-04.fa415d01.svg";